import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { fields } from "./constants";
import { useWelcomePageForCalendar } from "./Others.hook";
import { CalendarLegends } from "./CalendarLegends/CalendarLegends";
import { Banners } from "./Banners/Banners";
import { Icon } from "@iconify/react";

export const Others = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const {
    data: welcomePageForCalendarData,
    error,
    isLoading,
    isError,
    refetch: refetchData,
  } = useWelcomePageForCalendar();

  const id = query?.get("id");
  const {
    data: welcomePageForCalendarById,
    isLoading: isLoadingwelcomePageForCalendar,
    refetch: refetchDataById,
  } = useDocumentDetails(id || "");

  useEffect(() => {
    refetchData();
  }, [refetchData]);

  useEffect(() => {
    if (id) {
      refetchDataById();
    }
  }, [id, refetchDataById]);

  useEffect(() => {
    if(id){
      return;
    }
    if (!query.get("activeTab")) {
      navigate(`/dedicated/magp/others?activeTab=welcomePageForCalendar`, {
        replace: true,
      });
    }
    if(query.get('activeTab')==='banners'){
      if(query.get('subActiveTab')==='webFooterImages'){
        navigate(`/dedicated/magp/others?activeTab=banners&subActiveTab=${query.get('subActiveTab')||'webBannerImages'}&thirdChildActiveTab=${query.get('thirdChildActiveTab') ||'staffLoginFooterPage'}`, {
          replace: true,
        });
      } else{
        navigate(`/dedicated/magp/others?activeTab=banners&subActiveTab=${query.get('subActiveTab')||'webBannerImages'}`, {
          replace: true,
        });
      }
    }
  }, [navigate, query]);

  const welcomePageForCalendarConfig: FormConfig = {
    initialValues: {
      title: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.title)
        : decodeHTML(welcomePageForCalendarData?.[0]?.title),
      field_malay_calendar_header_text: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_malay_calendar_header_text)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_malay_calendar_header_text),
      field_mandarin_calendar_header_t: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_mandarin_calendar_header_t)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_mandarin_calendar_header_t),
      field_welcome_calendar_text: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_welcome_calendar_text)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_welcome_calendar_text),
      field_malay_welcome_calendar_tex: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_malay_welcome_calendar_tex)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_malay_welcome_calendar_tex),
      field_mandarin_welcome_calendar: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_mandarin_welcome_calendar)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_mandarin_welcome_calendar),
      field_welcome_calendar_descripti: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_welcome_calendar_descripti?.value)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_welcome_calendar_descripti),
      field_malay_welcome_calendar_des: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_malay_welcome_calendar_des?.value)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_malay_welcome_calendar_des),
      field_mandari_welco_calen_descri: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_mandari_welco_calen_descri?.value)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_mandari_welco_calen_descri),
      field_calendar_welcom_continue: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_calendar_welcom_continue)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_calendar_welcom_continue),
      field_malay_continue_text: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_malay_continue_text)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_malay_continue_text),
      field_mandarin_continue_text: welcomePageForCalendarById?.payload
        ? decodeHTML(welcomePageForCalendarById?.payload?.field_mandarin_continue_text)
        : decodeHTML(welcomePageForCalendarData?.[0]?.field_mandarin_continue_text),
      field_magp_image: welcomePageForCalendarById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "MAGP_image.png",
              status: "done",
              url: welcomePageForCalendarById?.payload?.field_magp_image?.[0]?.url,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "MAGP_image.png",
              status: "done",
              url: welcomePageForCalendarData?.[0]?.field_magp_image,
            },
          ]),
    },
    fields: fields.welcomePageForCalendar,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    // let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
      "field_magp_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let descKeys: any = [
      "field_welcome_calendar_descripti",
      "field_mandari_welco_calen_descri",
      "field_malay_welcome_calendar_des",
    ];
    for (const key of descKeys) {
      try {
        data[key] = {
          value: data[key] || "",
          format: "full_html",
        };
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "OTHERS",
      subModule: query?.get("activeTab"),
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        field_camera_created_at: "2024-04-09T01:03:09",
        field_camera_updated_at: "2024-04-09T01:03:09",
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          refetchDataById();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          refetchDataById();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const items = [
    {
      label: "Welcome Page For Calendar",
      key: "welcomePageForCalendar",
      children: (
        <DynamicForm
          isLoading={isLoading || isLoadingwelcomePageForCalendar}
          config={welcomePageForCalendarConfig}
          onSubmit={(data, buttonValue, reviewNotes) =>
            onSubmit(
              data,
              `${magpHost}/api/calendar-welcome/${welcomePageForCalendarData?.[0]?.id}`,
              "UPDATE",
              "PATCH",
              buttonValue == "save" ? "DRAFT" : "PENDING",
              reviewNotes
            )
          }
        />
      ),
    },
    {
      label: "Calendar Legends",
      key: "calendarLegends",
      children: <CalendarLegends/>
    },
    {
      label: "Banners",
      key: "banners",
      children: <Banners/>
    }
  ];

  const handleProductManagement=(activeTab:any)=>{
    if(activeTab === 'mobileHomepageBannerSlider') {
      return (<Button
      onClick={() => {
        navigate("/dedicated/magp/others/banners/mobileHomepageBannerSlider/add");
      }}
      icon={<Icon icon={"lucide:plus"} />}
      >
        Add Mobile Homepage Banner Slider
      </Button>
      )
    }
  }

  return (
    <ContentWrapper title={"Others"} bodyStyle={{height: "calc(100vh - 100px)", overflowY: "auto" }}
    actionItems={
      handleProductManagement(query.get('subActiveTab'))
    }>
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
